import React from "react";
import BaseTrackVehicleList from "./BaseTrackVehicleList";
import { COMPANY_DOMAINS } from "@routebot/constants";

const TrackPersonelVehicleList = () => {
  return <BaseTrackVehicleList mode={COMPANY_DOMAINS.PERSONEL} />;
};

export default TrackPersonelVehicleList;
